import React from 'react';
import { motion } from 'framer-motion';
import { Crown } from 'lucide-react';
import { Section } from './Section';
import { useLanguage } from './LanguageContext';
export function TheExperience() {
  const {
    t
  } = useLanguage();
  const steps = [t('experienceFlow.s1'), t('experienceFlow.s2'), t('experienceFlow.s3'), t('experienceFlow.s4'), t('experienceFlow.s5'), t('experienceFlow.s6')];
  return <Section className="bg-barber-black" data-id="element-420">
      <div className="max-w-3xl mx-auto" data-id="element-421">
        <h2 className="font-heading text-3xl md:text-4xl font-bold text-barber-text uppercase mb-16 text-center" data-id="element-422">
          {t('experienceFlow.heading1')} <br className="md:hidden" data-id="element-423" />
          <span className="text-barber-gold" data-id="element-424">
            {t('experienceFlow.heading2')}
          </span>
        </h2>
        <div className="space-y-6 mb-16 pl-4 md:pl-12 border-l-2 border-barber-gold/30" data-id="element-425">
          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="relative" data-id="element-426">
              <div className="absolute -left-[21px] md:-left-[53px] top-1/2 -translate-y-1/2 w-3 h-3 rounded-full bg-barber-gold" data-id="element-427"></div>
              <p className="text-xl md:text-2xl text-barber-muted font-light" data-id="element-428">
                <span className="text-barber-gold mr-4" data-id="element-429">→</span> {step}
              </p>
            </motion.div>)}
        </div>
        <div className="text-center space-y-8 bg-barber-gray p-8 md:p-12 rounded-sm border border-barber-lightGray" data-id="element-430">
          <p className="text-xl md:text-2xl text-barber-text leading-relaxed" data-id="element-431">
            {t('experienceFlow.p1')}
          </p>
          <p className="text-xl md:text-2xl text-barber-text" data-id="element-432">
            {t('experienceFlow.p2')}
          </p>
          <div className="pt-8" data-id="element-433">
            <Crown className="w-16 h-16 text-barber-gold mx-auto mb-6" strokeWidth={1.5} data-id="element-434" />
            <p className="font-heading text-5xl md:text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-barber-gold to-barber-goldHover uppercase tracking-widest" data-id="element-435">
              {t('experienceFlow.king')}
            </p>
          </div>
        </div>
      </div>
    </Section>;
}